<template>
  <v-container>
    <v-row
      class="box"
      :style="{
        background: setBackgoundBox(),
        borderRadius: isSticky ? '' : '28px',
      }"
      ><v-col cols="12" align-self="center">
        <v-row>
          <v-col cols="auto" align-self="center"
            ><div
              class="d-flex justify-center align-center"
              style="width: 80px; height: 80px"
            >
              <div
                class="level-box-icon d-flex justify-center align-center"
                style="
                  width: 64px;
                  height: 64px;
                  border-radius: 50%;
                  border: 4px solid #ffe082;
                  position: relative;
                "
              >
                <v-icon size="40" color="#ffffff" style="position: absolute"
                  >mdi-trophy-variant-outline</v-icon
                >
                <v-icon
                  size="10"
                  color="#ffffff"
                  style="position: absolute; margin-bottom: 12px"
                  >mdi-star</v-icon
                >
              </div>
            </div></v-col
          >
          <v-col class="pl-0 pr-6 py-4" style="width: calc(100% - 120px)">
            <v-row no-gutters class="pb-1">
              <div class="d-flex align-center" style="width: 100%">
                <v-chip
                  class="px-6"
                  style="
                    min-width: fit-content;
                    max-width: 160px;
                    font-size: 1rem;
                    border-width: 1px;
                  "
                  :style="{
                    // backgroundColor: `#FFD2FE !important`,
                    // color: `${getFontColorBasedOnBg('#FFD2FE')} !important`,
                    // backgroundColor: `${levelColor || '#cd7f31'} !important`,
                    background: `${setLevelBox(levelColor)}`,
                    color: `${getFontColorBasedOnBg(
                      levelColor || '#cd7f31'
                    )} !important`,
                  }"
                  color="white"
                  dark
                  outlined
                  ><span
                    style="
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    "
                    >{{ level }}</span
                  ></v-chip
                >
                <div
                  v-if="Array.isArray(point) && point.length > 0"
                  class="d-flex align-center justify-end white--text"
                  style="
                    width: calc(100% - 160px);
                    gap: 4px;
                    margin-right: 0px;
                    margin-left: auto;
                  "
                >
                  <PointSymbol
                    :type="point[0].point_type_type"
                    :symbol="point[0].point_type_symbol"
                    :color="point[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="32"
                  />
                  <div
                    class="d-flex align-center"
                    style="max-width: 100%; gap: 4px"
                  >
                    <div style="font-size: 20px; font-weight: bold">
                      {{ commaPoint(point[0].point || 0) }}
                    </div>
                    <div class="text-truncate" style="font-size: 16px">
                      {{ point[0].point_type_name }}
                    </div>
                  </div>
                </div>
              </div>
            </v-row>
            <v-row no-gutters class="pt-2">
              <v-col cols="12"
                ><v-progress-linear
                  :color="site.color || 'light-green'"
                  height="12"
                  :value="percentNextLevel()"
                  striped
                  style="border-radius: 8px"
                ></v-progress-linear
              ></v-col>
            </v-row>
            <v-row no-gutters class="pt-2">
              <v-col cols="auto">
                <div v-if="nextLevelName" class="description-level">
                  {{
                    $t("earnMoreForNextLevel", {
                      nextLevelEarn:
                        commaPoint(nextLevelEarn || 0) +
                        (nextLevelPointType && nextLevelPointType.name
                          ? " " + nextLevelPointType.name
                          : ""),
                      nextLevelName: nextLevelName,
                    })
                  }}
                </div>
                <div v-else class="description-level">
                  {{ $t("maxLevelReached") }}
                </div>
              </v-col>
            </v-row></v-col
          >
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  adjustHslBrightness,
  getFontColorBasedOnBg,
} from "@/config/general-function";
import PointSymbol from "../point/point-symbol.vue";

export default {
  components: { PointSymbol },
  props: [
    "isSticky",
    "level",
    "levelColor",
    "point",
    "history_point",
    "nextLevelName",
    "nextLevelEarn",
    "nextLevelPointType",
    "site",
  ],
  data() {
    return {
      dataItems: {},
    };
  },
  created() {},
  methods: {
    percentNextLevel() {
      let percent = 100;
      const _point = this.history_point || 0;
      const _nextLevelEarn = this.nextLevelEarn || 0;
      const max = _point + _nextLevelEarn;
      if (this.nextLevelName) {
        if (max > 0) {
          percent = (_point * 100) / max;
        }
      }
      return percent;
    },
    getFontColorBasedOnBg(param, param2) {
      const res = getFontColorBasedOnBg(param, param2);
      return res;
    },
    setBackgoundBox() {
      const _color = this.site.color || "#b24592";
      const darken = adjustHslBrightness(_color, -20);
      let _style = `linear-gradient(120deg, ${_color}, ${darken})`;
      return _style;
    },
    setLevelBox(levelColor) {
      const _color = levelColor || "#cd7f31";
      const darken = adjustHslBrightness(_color, -20);
      const lighten = adjustHslBrightness(_color, 20);
      let _style = `linear-gradient(20deg, ${darken}, ${_color}, ${lighten}) !important`;
      return _style;
    },
    commaPoint(value) {
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
  filters: {},
};
</script>

<style scoped>
::v-deep .v-progress-linear__background {
  opacity: 0 !important;
  background-color: #ffffff !important;
}
::v-deep .v-progress-linear__buffer {
  opacity: 0.3 !important;
  background-color: #ffffff !important;
}
::v-deep .v-progress-linear__determinate {
  border-radius: 8px;
}
.box {
  height: 140px;
}

.level-box-icon {
  background: #f2994a; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    160deg,
    #f2c94c,
    #f2994a
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    160deg,
    #f2c94c,
    #f2994a
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.description-level {
  font-size: 0.9rem;
  color: #fafafa;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
